import React from 'react'
import { storiesOf } from '@storybook/react'

import RankBadge from 'components/RankBadge'

import Grid from '@material-ui/core/Grid'

storiesOf('RankBadge', module)
  .add('default', () => (
    <Grid container>
      <Grid item xs={4}>
        <RankBadge rank={1} size="large" />
        <RankBadge rank={1} />
        <RankBadge rank={1} size="small" />
      </Grid>
      <Grid item xs={4}>
        <RankBadge rank={2} size="large" />
        <RankBadge rank={2} />
        <RankBadge rank={2} size="small" />
      </Grid>
      <Grid item xs={4}>
        <RankBadge rank={3} size="large" />
        <RankBadge rank={3} />
        <RankBadge rank={3} size="small" />
      </Grid>
    </Grid>
  ))
